import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useRoles } from "@/hooks/useRole";
import type { FeatureFlag } from "@/lib/featureFlags";

/**
 * Guards a route behind a feature flag. When the flag is off and the user is
 * not a super_admin, the user is redirected to `/`. While roles are still
 * loading we render nothing to avoid a redirect flash for super_admins.
 */
const FeatureFlagRoute = ({
  flag,
  children,
}: {
  flag: FeatureFlag;
  children: ReactNode;
}) => {
  const { loading } = useRoles();
  const allowed = useFeatureFlag(flag);
  if (loading) return null;
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default FeatureFlagRoute;